import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const promotions = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 1000,
            total: 0,
            page: 1,
            groupID: null,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setPromotions(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedPromotions(state, payload) {
            state.selectedItems = payload;
        },
        setPromotionPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getPromotions');
        },
        setPromotionTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getPromotions');
        },
    },
    actions: {
        async togglePromotions(store, payload) {
            var res = await axios.post('/promotion/toggleisactive', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res.data;
        },
        async getPromotions(store) {
            store.state.loading = true;
            var res = await axios.post('promotion/list', {...store.state.filter });
            store.state.loading = false;
            store.commit('setPromotions', res.data.data);
        },
        async togglePromotion(store, payload) {
            var res = await axios.post('speaker/toggleisactive', {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async getPromotionOneItem(store, payload) {
            var res = await axios.post('promotion/get', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            }
            return res;
        },
        async deletePromotion(store, payload) {
            var res = await axios.post('promotion/delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};
export default promotions;


// WEBPACK FOOTER //
// ./src/store/promotions.js